import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackGBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackGBlue" transform="translate(1871.000000, 596.000000)" className="track">
		<line
			x1="32.2720802" y1="34.5562879" x2="0" y2="24" id="line"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"
		/>

		<TrackArrow
			transform="translate(29.768707, 33.451782) rotate(-163.000000) translate(-29.768707, -33.451782) "
			points="33.7687072 41.4517819 25.7687072 33.4517819 33.7687072 25.4517819"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackGBlue')}
			coords="6.000000, 0.000000"
			text="G"
			textCoordsX="8.0"
			textCoordsY="17.1388889"
			size="small"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackGBlue.propTypes = trackPropTypes;

export default TrackGBlue;
